var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EventButton',{class:_vm.eventButtonCssClasses,attrs:{"event":_vm.buttonEvent,"data":_vm.eventData,"label":_vm.label}},[_c('template',{slot:"icon"},[_vm._t("wishlist-icon",[_c('HeartIcon',{class:_vm.iconCssClasses})])],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }